import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { CompanyInfo } from '../../customer-admin.model';

export const getCompanyInfo = createAction(
    '[CompanyInfo/API] GET CompanyInfo',
    props<{ customerid: string; IsInternal: boolean }>()
);

export const putCompanyInfo = createAction(
    '[CompanyInfo/API] PUT CompanyInfo',
    props<{ JsonString: any }>()
);

export const loadCompanyInfos = createAction(
    '[CompanyInfo/API] Load CompanyInfos',
    props<{ CompanyInfos: any[] }>()
);

export const addCompanyInfo = createAction(
    '[CompanyInfo/API] Add CompanyInfo',
    props<{ CompanyInfo: CompanyInfo }>()
);

export const upsertCompanyInfo = createAction(
    '[CompanyInfo/API] Upsert CompanyInfo',
    props<{ JsonString: string }>()
);

export const addCompanyInfos = createAction(
    '[CompanyInfo/API] Add CompanyInfos',
    props<{ CompanyInfos: CompanyInfo[] }>()
);

export const upsertCompanyInfos = createAction(
    '[CompanyInfo/API] Upsert CompanyInfos',
    props<{ CompanyInfos: CompanyInfo[] }>()
);

export const updateCompanyInfo = createAction(
    '[CompanyInfo/API] Update CompanyInfo',
    props<{ CompanyInfo: Update<CompanyInfo> }>()
);

export const updateCompanyInfos = createAction(
    '[CompanyInfo/API] Update CompanyInfos',
    props<{ CompanyInfos: Update<CompanyInfo>[] }>()
);

export const deleteCompanyInfo = createAction(
    '[CompanyInfo/API] Delete CompanyInfo',
    props<{ id: string }>()
);

export const deleteCompanyInfos = createAction(
    '[CompanyInfo/API] Delete CompanyInfos',
    props<{ ids: string[] }>()
);

export const clearCompanyInfos = createAction('[CompanyInfo/API] Clear CompanyInfos');
